// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2jFWJ","footer":"ChangeClinic_footer__meGJ0"};